var scope_0 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7d832a47534afc721d747568229956f9.js').default;
var scope_1 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ab085d89c57c9c7b62af21fd567a953d.js').default;
var scope_2 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e683cd632f01f4cc1702ebee6df28d62.js').default;
var scope_3 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    